const t = "_button_1o04j_1", n = "_loading_1o04j_136", o = "_chevron_1o04j_149", e = "_leftIcon_1o04j_153", _ = "_rightIcon_1o04j_158", c = "_buttonText_1o04j_172", a = {
  button: t,
  "button--full-width": "_button--full-width_1o04j_132",
  loading: n,
  "button--alignment-center": "_button--alignment-center_1o04j_140",
  "button--alignment-space-between": "_button--alignment-space-between_1o04j_143",
  "button--alignment-separate": "_button--alignment-separate_1o04j_146",
  chevron: o,
  leftIcon: e,
  rightIcon: _,
  buttonText: c
};
export {
  t as button,
  c as buttonText,
  o as chevron,
  a as default,
  e as leftIcon,
  n as loading,
  _ as rightIcon
};
//# sourceMappingURL=index.es780.js.map
